"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BanklistStandardDateFmt = exports.Banks = void 0;
var Banks;
(function (Banks) {
    Banks[Banks["NorthernTrust"] = 4] = "NorthernTrust";
    Banks[Banks["StateStreet"] = 5] = "StateStreet";
})(Banks || (exports.Banks = Banks = {}));
exports.BanklistStandardDateFmt = "YYYY-MM-DD";
